export default __webpack_public_path__ + "static/media/calendar-icon.8c419757.svg";